import React, { Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames/bind';
import TaskOwnerSwitcher from '../component/TaskOwnerSwitcher';
import { fetchGeneralSettings } from '../flow/action';
import styles from '../index.less';


const cx = classNames.bind(styles);

const GeneralSettings = ({
  fetchGeneralSettings
}) => {
  useEffect(() => {
    fetchGeneralSettings();
  }, [fetchGeneralSettings]);

  return (
    <Fragment>
      <FormattedMessage id="global.sider.generalSettings">
        {text => <div className={classNames(cx('general-setting-title'), 'ml-lg', 'mt-sm', 'mb-md')}>{text}</div>}
      </FormattedMessage>
      <TaskOwnerSwitcher />
    </Fragment>
  );
};

const mapStateToProps = ({ global }) => ({
  lang: global.language,
});

const mapDispatchToProps = {
  fetchGeneralSettings
};


export default connect(mapStateToProps, mapDispatchToProps)(GeneralSettings);



// WEBPACK FOOTER //
// ./src/views/Setup/GeneralSettings/container/index.jsx